import { GUIDE_CLASS } from '../const';

export const indentGuidesOverlay = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  token(stream: any) {
    let char = '';
    let colNum = 0;
    let spaceUnits = 0;
    let isTabStart = false;

    char = stream.next();
    colNum = stream.column();

    if (char === '\t') {
      return GUIDE_CLASS;
    }

    if (char !== ' ') {
      stream.skipToEnd();
      return null;
    }

    spaceUnits = 2;
    isTabStart = !(colNum % spaceUnits);

    if (char === ' ' && isTabStart) {
      return GUIDE_CLASS;
    } else {
      return null;
    }
  },
  flattenSpans: false,
};
